import { TFunction } from 'i18next';

export default function getNotFoundText(
  search: string | null | undefined,
  type: string,
  typePlural: string,
  t: TFunction
): JSX.Element {
  const isSearchBlank = search?.replaceAll(' ', '').length === 0;
  const typeFirstLetterUpperCase =
    type[0].toUpperCase() + type.slice(1).toLowerCase();
  const typeLowerCase = typePlural.toLowerCase();

  return Boolean(search) ? (
    isSearchBlank ? (
      <span dangerouslySetInnerHTML={{ __html: t('common.foundSpacebar', { typeLowerCase }) as string }} />
    ) : (
      <span dangerouslySetInnerHTML={{ __html: t('common.searchNoMatch', { search, typeLowerCase }) as string }} />
    )
  ) : (
    <span>{t('common.itemNotFound', { type: typeFirstLetterUpperCase })}</span>
  );
}
